import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import {
  StyledBackgroundColorPicker,
  StyledBackgroundColorTrigger,
} from './index.style';

const isHexColor = (color) => /^#[0-9a-fA-F]{6}$/.test(color || '');

const BackgroundColorPicker = ({ value, onChange, disabled = false }) => {
  const { t } = useTranslation();

  const normalizedValue = isHexColor(value) ? value : COLOR.black.default;

  const handleChange = (event) => {
    onChange(event.target.value);
  };

  return (
    <StyledBackgroundColorPicker>
      <StyledBackgroundColorTrigger isDisabled={disabled}>
        <span
          className="background-color-dot"
          style={{ backgroundColor: normalizedValue }}
        />
        <Typography variant="body-14-regular">
          {t('videoDubbingBgColor')}
        </Typography>
        <input
          type="color"
          value={normalizedValue}
          onChange={handleChange}
          disabled={disabled}
          className="background-color-input"
        />
      </StyledBackgroundColorTrigger>
    </StyledBackgroundColorPicker>
  );
};

export default BackgroundColorPicker;
